import { createSelector } from 'reselect';
import locationSelector from './location';
import { VISITED_ROOT } from '../const';

const DEFAULT = VISITED_ROOT;

export default createSelector(locationSelector, location => location.type || DEFAULT);
